import { RadioGroup, Stack, Typography } from '@mui/material'
import { TemplateLayoutTypeEnum } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useId } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import LayoutScroll1Svg from 'src/assets/icons/layout_scroll_1.svg?react'
import LayoutScroll2Svg from 'src/assets/icons/layout_scroll_2.svg?react'
import LayoutSlideSvg from 'src/assets/icons/layout_slide.svg?react'
import { isLegacyCompany } from 'src/features/legacyFeatures/isLegacyCompany'
import { updateLayoutType } from 'src/state/ducks/templates/editTemplate/actions'
import type { RootState } from 'src/state/store'
import LayoutRadioRow from './LayoutRadioRow'

const LayoutRow: FC = () => {
  // @legacy-feature: 表形式、スクロール2列、紙芝居廃止
  const isLegacy = isLegacyCompany()
  const dispatch = useDispatch()
  const layoutType = useSelector(
    (state: RootState) => state.templatesState.editTemplate.layoutType,
    shallowEqual,
  )
  const labelId = useId()

  // 新規顧客にはレイアウト選択を表示しない（スクロール1列固定）
  if (!isLegacy) return null

  return (
    <Stack spacing={1} sx={{ mx: 2 }}>
      <Typography variant="subtitle1" id={labelId}>
        ひな形のレイアウト
      </Typography>
      <RadioGroup
        aria-labelledby={labelId}
        name="layout-type"
        value={String(layoutType ?? '')}
        onChange={e =>
          dispatch(
            updateLayoutType(Number(e.target.value) as TemplateLayoutTypeEnum),
          )
        }
      >
        <LayoutRadioRow
          value={String(TemplateLayoutTypeEnum.Scroll)}
          name="スクロール(1列)"
          description={[
            'セクション内の全ての質問が１ページ内に表示されます。（従来）',
          ]}
          Image={LayoutScroll1Svg}
        />
        <LayoutRadioRow
          value={String(TemplateLayoutTypeEnum.ScrollTwoColumn)}
          name="スクロール(2列)"
          description={[
            'セクション内の全ての質問が１ページ内に二列で表示されます。予め設定したデフォルト回答で完結する定常チェックにおすすめです。',
          ]}
          Image={LayoutScroll2Svg}
        />
        <LayoutRadioRow
          value={String(TemplateLayoutTypeEnum.Slide)}
          name="紙芝居"
          description={[
            '一度に１質問しか表示されません。回答後自動的に次の質問に進みます。',
          ]}
          Image={LayoutSlideSvg}
        />
      </RadioGroup>
    </Stack>
  )
}

export default LayoutRow
